import { withTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { useMytaverse } from '@providers/MytaverseProvider';
import AppHeader from '@components/AppHeader';
import AppLogo from '@components/AppLogo';
import ROUTES from '@constants/routes';

import { IAppWrapper } from './interfaces';
import { useStyles } from './styles';

const AppWrapper = ({
  children,
  isAuthorized,
  backdrop = null,
  logoHasRedirection = true,
  moreSpaceAbove = false,
  t: translate,
}: IAppWrapper) => {
  const classes = useStyles(moreSpaceAbove);
  const { skipLinkInHeader } = useMytaverse();

  return (
    <Box sx={classes.root}>
      {backdrop}
      <AppHeader isAuthorized={isAuthorized} />
      <Box sx={classes.wrapbox}>
        <Box sx={classes.content}>
          <Box sx={classes.header}>
            <AppLogo
              {...(logoHasRedirection && {
                to: isAuthorized ? ROUTES.SELECT_EVENT : ROUTES.LOGIN,
              })}
            />
            {!!skipLinkInHeader && (
              <Typography sx={classes.skip} onClick={skipLinkInHeader}>
                {translate('skip')}
              </Typography>
            )}
          </Box>
          <Box sx={classes.children}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default withTranslation()(AppWrapper);
